import { Box, Grid, TextField, Typography } from "@mui/material"
import { BarChart, axisClasses, chartsGridClasses } from "@mui/x-charts"
import { useEffect, useState } from "react";
import { getAnswersByBlockAndUser, getAnswersByBlockAndUserTIM } from "../axios/axiosFunctions";

// `groupId` is optional. When present (TIM-family team assessments) answers are
// group-scoped, so we use the group-aware endpoint — a member can sit in more
// than one team and we must show only this team's responses. Without it we fall
// back to the per-user endpoint used by the self-assessment profile report.
const BlockReportProfile = ({info,blockId,color,questionLength,userId,groupId}) => {

    const [defaultAnswer, setDefaultAnswer] = useState();
    const [questionsAnswers, setQuestionsAnswers] = useState([]);
    const [currentBlockText, setCurrentBlockText] = useState("");

    useEffect(() => {
        const getAnswers = async()=>{
            const res = groupId
                ? await getAnswersByBlockAndUserTIM(blockId,userId,groupId)
                : await getAnswersByBlockAndUser(blockId,userId);
            if(res){ //TODO MANAGE ERROR
                if(res?.answers.length > questionLength){
                    const defValueReportQuestion = res.answers.pop();
                    setDefaultAnswer(defValueReportQuestion);
                }
                const data = res.answers.map((blockInfo)=>({
                    resp: formatResp(blockInfo.answer),
                    question: blockInfo.question.text
                }));
                setQuestionsAnswers(data);
            }
        }
        getAnswers();
    }, [blockId,userId,groupId,questionLength]);

    useEffect(() => {
        const infoBlock = (info || []).find((b)=>b.block === blockId);
        setCurrentBlockText(infoBlock?.text || "");
    }, [blockId,info]);

    const formatResp = (resp)=>{
        const obj = {
            unable: 1,
            notConfident: 2,
            somewhat: 3,
            confident: 4,
            very: 5
        }
        return obj[resp] || 0;
    }

    const formatLabel = (resp)=>{
        switch (resp) {
            case 1:
                return "Unable to Respond";
            case 2:
                return "Not Confident";
            case 3:
                return "Somewhat Confident";
            case 4:
                return "Confident";
            case 5:
                return "Very Confident";
            default:
                return "";
        }
    };

    const wrapLabel = (s, max = 28) => {
        return s
        .split(' ')
        .reduce((lines, w) => {
            const last = lines[lines.length - 1];
            if (!last || (last + ' ' + w).length > max) lines.push(w);
            else lines[lines.length - 1] = last + ' ' + w;
            return lines;
        }, [])
        .join('\n'); // <- clave: inyecta \n
    };

    return (
    <Box className="padLeft padRight" display="flex" flexDirection="column">
        <Grid container spacing={2} sx={{margin:"50px 0px 70px 0px"}}>
            <Grid size={12}>
                <Typography variant="h6" fontWeight={400} sx={{marginTop:"5px",lineHeight:"1.5",whiteSpace:"pre-wrap"}}>{currentBlockText}</Typography>
            </Grid>
            <Grid size={12}>
                <BarChart
                    dataset={questionsAnswers}
                    xAxis={[{min:0,max:5,valueFormatter:formatLabel,tickNumber:5,tickLabelStyle:{fontSize:12},position:"top"}]}
                    yAxis={[{scaleType:"band",dataKey:"question",width:1000,tickLabelStyle:{fontSize:20,fontWeight:400,whiteSpace:"normal",textOverflow:"unset"},valueFormatter:(v) => wrapLabel(String(v), 55)}]}
                    series={[{dataKey:"resp"}]}
                    layout="horizontal"
                    grid={{vertical:true}}
                    colors={[color]}
                    height={800}
                    margin={{right:100,left:-400}}
                    slotProps={{tooltip:{trigger:"none"}}}
                    sx={{ 
                        [`& .${axisClasses.tickLabel}`]: {
                        whiteSpace: 'pre-wrap',
                        overflow: 'visible',
                        textOverflow: 'unset',
                        },
                        [`& .${chartsGridClasses.line}`]: { strokeWidth: 4 },
                    }}
                />
            </Grid>
            <Grid size={12}>
                <Typography variant="h6" fontWeight={600} color={color}>What stands out as a priority focus area in this section? Where might you want to focus?</Typography>
                <TextField disabled defaultValue={defaultAnswer?.answer} fullWidth multiline rows={5}/>
            </Grid>
        </Grid>
    </Box>
    )
}

export default BlockReportProfile